(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["i1-auto-ad"] && !Shopify.designMode) return;
  try {
    
function initAutoPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('#AutoTintContact');if(!form)return;
 const result=form.querySelector('.success,.form-errors');if(result){result.setAttribute('tabindex','-1');result.focus();}
 const submit=form.querySelector('[type="submit"]');if(!submit)return;
 const checks=[...form.querySelectorAll('[data-glass]')];
 const params=new URLSearchParams(location.search);
 const vehicle=params.get('vehicle');if(['car','suv','truck'].includes(vehicle))form.querySelector('[data-model="'+vehicle+'"]').checked=true;
 const campaign=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].map(k=>{const v=params.get(k);return v?k+'='+v.slice(0,250):''}).filter(Boolean).join(' | ');
 form.querySelector('[data-campaign]').value=campaign||'Direct or untagged visit';
 function update(changed){
  const model=form.querySelector('[data-model]:checked'),film=form.querySelector('[data-choice-film]:checked');
  const front=checks.find(c=>c.dataset.glass==='front'),sides=checks.find(c=>c.dataset.glass==='sides');
  const isCar=model.dataset.model==='car';front.disabled=isCar;front.closest('label').hidden=isCar;
  if(isCar&&front.checked){front.checked=false;sides.checked=true;}
  if(isCar)front.checked=false;
  if(changed&&changed.checked&&!changed.disabled&&['front','sides'].includes(changed.dataset.glass))checks.find(c=>c.dataset.glass===(changed.dataset.glass==='front'?'sides':'front')).checked=false;
  form.querySelector('[data-summary-model]').textContent=model.value;
  form.querySelector('[data-summary-film]').textContent=film.value;
  const list=form.querySelector('[data-line-items]');list.replaceChildren();const lines=[];
  for(const c of checks.filter(c=>c.checked&&!c.disabled)){
   const label=c.closest('label').querySelector('b').textContent;
   const li=document.createElement('li');li.textContent=label;list.append(li);lines.push(label);
  }
  form.querySelector('[data-package]').value=['Non-Tesla window tint request','Vehicle type: '+model.value,'Film preference: '+film.value,'Coverage: '+lines.join(', '),'Vehicle: '+['Model year','Make','Model'].map(k=>form.elements.namedItem('contact['+k+']').value).join(' '),'Quote and installation request; no appointment reserved.',campaign].filter(Boolean).join('\n');
  const empty=lines.length===0;submit.disabled=empty;form.querySelector('[data-selection-error]').hidden=!empty;
 }
 form.addEventListener('change',e=>update(e.target));form.addEventListener('input',()=>update());
 root.querySelectorAll('[data-film]').forEach(a=>a.addEventListener('click',()=>{form.querySelector('[data-choice-film="'+a.dataset.film+'"]').checked=true;update();}));
 form.addEventListener('submit',e=>{update();if(!checks.some(c=>c.checked&&!c.disabled))e.preventDefault();});
 update();
}
document.querySelectorAll('.auto-page').forEach(initAutoPage);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.auto-page').forEach(initAutoPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i1-google-reviews"] && !Shopify.designMode) return;
  try {
    
function initI1Reviews(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const slides=[...root.querySelectorAll('.i1-reviews__slide')];
  const pause=root.querySelector('[data-pause]');
  const count=root.querySelector('[data-count]');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  let index=0,paused=reduce.matches,hover=false,focused=false,timer;
  function label(){pause.textContent=paused?pause.dataset.playLabel:pause.dataset.pauseLabel;pause.setAttribute('aria-pressed',String(paused));}
  function show(next){slides[index].hidden=true;index=(next+slides.length)%slides.length;slides[index].hidden=false;count.textContent=(index+1)+' / '+slides.length;}
  function schedule(){clearInterval(timer);if(!paused&&!hover&&!focused&&slides.length>1)timer=setInterval(()=>show(index+1),9000);}
  root.querySelector('[data-prev]').addEventListener('click',()=>{show(index-1);schedule();});
  root.querySelector('[data-next]').addEventListener('click',()=>{show(index+1);schedule();});
  pause.addEventListener('click',()=>{paused=!paused;label();schedule();});
  root.addEventListener('mouseenter',()=>{hover=true;schedule();});
  root.addEventListener('mouseleave',()=>{hover=false;schedule();});
  root.addEventListener('focusin',()=>{focused=true;schedule();});
  root.addEventListener('focusout',(event)=>{if(!root.contains(event.relatedTarget)){focused=false;schedule();}});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)clearInterval(timer);else schedule();});
  reduce.addEventListener('change',()=>{paused=reduce.matches;label();schedule();});
  label();schedule();
}
document.querySelectorAll('[data-i1-reviews]').forEach(initI1Reviews);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-i1-reviews]').forEach(initI1Reviews));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i1-marine-ad"] && !Shopify.designMode) return;
  try {
    
function initMarinePage(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const form=root.querySelector('#MarineBoatContact');if(!form)return;
const boxes=[...form.querySelectorAll('.checks input')];if(!boxes.length)return;
const params=new URLSearchParams(location.search);const campaign=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].map(k=>params.get(k)?k+'='+params.get(k).slice(0,250):'').filter(Boolean).join(' | ');
form.querySelector('[data-marine-campaign]').value=campaign||'Direct or untagged visit';
function update(){const list=root.querySelector('#boat-summary');list.replaceChildren();const chosen=boxes.filter(b=>b.checked);for(const b of chosen){const li=document.createElement('li');li.textContent=b.closest('label').textContent.trim();list.append(li)}if(!chosen.length){const li=document.createElement('li');li.textContent=root.dataset.none;list.append(li)}
const field=k=>form.elements.namedItem('contact['+k+']').value.trim();
form.querySelector('[data-marine-message]').value=['MARINE / BOAT CARE LEAD','Requested services: '+(chosen.map(b=>b.value).join(', ')||'Help me choose'),'Boat: '+field('Boat make and model'),'Length (feet): '+field('Boat length feet'),'Boat year: '+field('Boat year'),'Pull-out timing: '+field('Pull-out timing'),'Condition and goals: '+field('Current condition and goals'),'Landing page: Lake Norman boat care','Campaign: '+(campaign||'Direct or untagged visit')].join('\n');}
form.addEventListener('change',update);form.addEventListener('input',update);form.addEventListener('submit',update);root.querySelectorAll('[data-select]').forEach(a=>a.addEventListener('click',()=>{boxes.find(b=>b.value===a.dataset.select).checked=true;boxes.find(b=>b.value==='Help me choose').checked=false;update()}));update();
}
document.querySelectorAll('.marine-page').forEach(initMarinePage);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.marine-page').forEach(initMarinePage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i1-tesla-ad"] && !Shopify.designMode) return;
  try {
    
function initTeslaPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('#TeslaTintContact');if(!form)return;
 const result=form.querySelector('.success,.form-errors');if(result){result.setAttribute('tabindex','-1');result.focus();result.scrollIntoView({block:'center'});}
 const submit=form.querySelector('[type="submit"]');if(!submit)return;
 const prices=JSON.parse(root.querySelector('[data-prices]').textContent);
 const checks=[...form.querySelectorAll('[data-glass]')];
 const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(n);
 const params=new URLSearchParams(location.search);
 if(['model3','model-3'].includes(params.get('vehicle')))form.querySelector('[data-model="3"]').checked=true;
 if(params.get('vehicle')==='cybertruck')form.querySelector('[data-model="truck"]').checked=true;
 if(params.get('film')==='plus')form.querySelector('[data-choice-film="plus"]').checked=true;
 const campaign=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].map(k=>{const v=params.get(k);return v?k+'='+v.slice(0,250):''}).filter(Boolean).join(' | ');
 form.querySelector('[data-campaign]').value=campaign||'Direct or untagged visit';
 function update(changed){
  const model=form.querySelector('[data-model]:checked'),film=form.querySelector('[data-choice-film]:checked');
  const front=checks.find(c=>c.dataset.glass==='front');
  const isModel3=model.dataset.model==='3';
  front.disabled=isModel3;front.closest('label').hidden=isModel3;
  if(isModel3)front.checked=false;
  const hint=front.closest('fieldset').querySelector('.hint');
  if(hint)hint.hidden=isModel3;
  if(changed&&changed.checked&&!changed.disabled&&['front','sides'].includes(changed.dataset.glass))checks.find(c=>c.dataset.glass===(changed.dataset.glass==='front'?'sides':'front')).checked=false;
  const row=prices[model.dataset.model][film.dataset.choiceFilm];
  for(const c of checks)form.querySelector('[data-price="'+c.dataset.glass+'"]').textContent=money(row[c.dataset.glass]);
  form.querySelector('[data-summary-model]').textContent=model.value;
  form.querySelector('[data-summary-film]').textContent=film.value;
  const list=form.querySelector('[data-line-items]');list.replaceChildren();
  let total=0;const lines=[];
  for(const c of checks.filter(c=>c.checked&&!c.disabled)){
   const label=c.closest('label').querySelector('b').textContent;const amount=row[c.dataset.glass];total+=amount;
   const li=document.createElement('li'),name=document.createElement('span'),price=document.createElement('b');name.textContent=label;price.textContent=money(amount);li.append(name,price);list.append(li);lines.push(label+': '+money(amount));
  }
  form.querySelector('[data-total]').textContent=money(total);
  form.querySelector('[data-package]').value=[model.value,film.value,...lines,'Subtotal: '+money(total)+' USD','Before taxes and shop fees. Film removal quoted separately.','Installation request only; no payment collected.',campaign].filter(Boolean).join('\n');
  const empty=!checks.some(c=>c.checked&&!c.disabled);submit.disabled=empty;form.querySelector('[data-selection-error]').hidden=!empty;
 }
 form.addEventListener('change',e=>update(e.target));
 root.querySelectorAll('[data-film]').forEach(a=>a.addEventListener('click',()=>{form.querySelector('[data-choice-film="'+a.dataset.film+'"]').checked=true;update();}));
 form.addEventListener('submit',e=>{update();if(!checks.some(c=>c.checked&&!c.disabled))e.preventDefault();});
 update();
}
document.querySelectorAll('.tesla-page').forEach(initTeslaPage);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.tesla-page').forEach(initTeslaPage));

  } catch(e) { console.error(e); }
})();
})();
